import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import Text from 'components/styles/text/Text';

const SmallLightText = styled(Text)(
  css({
    fontSize: 12,
  })
);

export default SmallLightText;
